(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/dialogs/payment-success-content.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/dialogs/payment-success-content.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
const formatText = svs.tur.pay.utils.format_text;

function getSuccessTitle(_ref) {
  let product = _ref.product,
    isSyndicate = _ref.isSyndicate,
    _ref$successfulWagers = _ref.successfulWagers,
    successfulWagers = _ref$successfulWagers === void 0 ? [] : _ref$successfulWagers,
    _ref$failedWagers = _ref.failedWagers,
    failedWagers = _ref$failedWagers === void 0 ? [] : _ref$failedWagers,
    _ref$failedTickets = _ref.failedTickets,
    failedTickets = _ref$failedTickets === void 0 ? [] : _ref$failedTickets;
  const customer = isSyndicate ? 'Ert' : 'Ditt';
  let productName = productMapping.getProductName(product) || product;
  if (productMapping.isVikinglotto(product)) {
    const hasJoker = successfulWagers[0].wager.bets.some(b => productMapping.isJoker(b.productId));
    if (hasJoker) {
      productName += ' & Joker';
    }
  }
  if (failedWagers.length || failedTickets.length) {
    return "".concat(customer, " ").concat(productName, " \xE4r betalat, men med en justering.");
  }
  return "".concat(customer, " ").concat(productName, " \xE4r betalat. Lycka till!");
}

function getSuccessMessages(_ref2) {
  let product = _ref2.product,
    price = _ref2.price,
    isSyndicate = _ref2.isSyndicate,
    syndicate = _ref2.syndicate,
    grassrootsReceivers = _ref2.grassrootsReceivers,
    chances = _ref2.chances,
    _ref2$successfulTicke = _ref2.successfulTickets,
    successfulTickets = _ref2$successfulTicke === void 0 ? [] : _ref2$successfulTicke,
    _ref2$failedWagers = _ref2.failedWagers,
    failedWagers = _ref2$failedWagers === void 0 ? [] : _ref2$failedWagers,
    _ref2$failedTickets = _ref2.failedTickets,
    failedTickets = _ref2$failedTickets === void 0 ? [] : _ref2$failedTickets;
  const messages = [];
  const mybetsHomeLink = "".concat(svs.core.urlMapping.get('myBetsHome'), "?grassrootstoasterredirect");
  const isAcChances = chances && productMapping.isLotto(product);
  const isCampaignChances = chances && !productMapping.isLotto(product);
  const formatChances = chances => chances > 1 ? "".concat(chances, " nya chanser") : '1 ny chans';
  const customer = isSyndicate ? 'Ni' : 'Du';
  if (failedWagers.length || failedTickets.length) {
    var _failedTickets$;
    const ticketFailedText = failedTickets.length === 1 ? (_failedTickets$ = failedTickets[0]) === null || _failedTickets$ === void 0 ? void 0 : _failedTickets$.product : "".concat(failedTickets.length, " Trisslotter");
    let failedProducts = failedWagers.map(_ref3 => {
      let wager = _ref3.wager;
      return productMapping.getProductDayName(wager.bets[0].productId);
    });
    if (failedTickets.length) {
      failedProducts = failedProducts.concat(ticketFailedText);
    }
    messages.push("".concat(formatText.joinWithPunctuation(failedProducts), " gick inte att betala och har d\xE4rf\xF6r exkluderats ur ").concat(isSyndicate ? 'ert' : 'ditt', " k\xF6p. Priset justerades till ").concat(price, " kr."));
  }
  const getMybetsMessage = () => {
    if (isSyndicate) {
      const syndicateLink = "".concat(svs.core.urlMapping.get('playTogetherTeams'), "?syndicateId=").concat(syndicate === null || syndicate === void 0 ? void 0 : syndicate.syndicateId, "&grassrootstoasterredirect");
      return "Du hittar ditt spel under <a href=\"".concat(syndicateLink, "\">Spela tillsammans</a> och <a href=\"").concat(mybetsHomeLink, "\">Mina spel</a>.");
    }
    let message = "Se dina lagda spel i <a href='".concat(mybetsHomeLink, "'>Mina spel</a>.");
    if (chances) {
      message = "Se dina lagda spel och extrachanser i <a href='".concat(mybetsHomeLink, "'>Mina spel</a>.");
    }
    if (successfulTickets.length) {
      message += "<br>D\xE4r v\xE4ntar \xE4ven ".concat(successfulTickets.length === 1 ? 'din Trisslott' : 'dina Trisslotter', " p\xE5 dig.</br>");
    }
    return message;
  };
  messages.push(getMybetsMessage());
  if (successfulTickets.length) {
    messages.push("<strong>Vill du skrapa ".concat(successfulTickets.length === 1 ? 'din' : 'en', " Trisslott direkt?</strong>"));
  }
  if (isAcChances) {
    messages.push("".concat(customer, " fick ").concat(formatChances(chances), " att vinna p\xE5 Andra Chansen."));
  }
  if (isCampaignChances) {
    messages.push("".concat(customer, " fick ").concat(formatChances(chances), " i ").concat(productMapping.getProductName(product), " kampanj."));
  }
  if (isSyndicate) {
    messages.push('Spelet skapar Gräsrotenpoäng om lagmedlemmar stöder föreningar');
  }
  if (Array.isArray(grassrootsReceivers) && grassrootsReceivers.length) {
    messages.push("".concat(formatText.joinWithPunctuation(grassrootsReceivers), " tackar f\xF6r ditt st\xF6d genom Gr\xE4sroten."));
  }
  return messages;
}
Object.assign(svs.tur.pay.dialogs, {
  getSuccessTitle,
  getSuccessMessages
});

 })(window);